import React, { useState } from "react";
import "../App.css";
import { useHistory } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  Button,
  Form,
  FormFeedback,
  FormGroup,
  Label,
  Input,
  FormText,
} from "reactstrap";
import axios from "axios";
import { toast } from "react-toastify";

const SignUp = () => {
  const newUser = (e) => {
    e.preventDefault();
    axios({
      method: "POST",
      url: "https://aqueous-plains-06808.herokuapp.com/api/v1/users/sign_up",
      headers: {
        "content-type": "application/json",
      },
      data: {
        username: name,
        email: email,
        password: pass,
      },
    })
      .then((re) => {
        // console.log(re);
        if (re) {
          toast.success("Sign up successful..Please login now", {
            position: "top-left",
          });
          history.push("./");
        } else {
          toast("Try again..");
        }
      })
      .catch((error) => {
        console.error(error.response); // so that we know what went wrong if the request failed
        toast("error,Try again..");
      });
  };

  const Pcheck = () => {
    return pass === Cpass;
  };

  const [email, setemail] = useState("");
  const [name, setname] = useState("");
  const [pass, setpass] = useState("");
  const [Cpass, Csetpass] = useState("");
  const history = useHistory();
  const [nameValidity, setValidity] = useState(true);
  const [delayId, setDelay] = useState(null);
  let enabled =
    email.length > 0 && pass.length > 0 && Cpass.length > 0 && name.length > 0;

  // const userCheck = (e) => {
  //   //   axios
  //   //     .get(
  //   //       `https://insta.nextacademy.com/api/v1/users/check_name?username=${newUsername}`
  //   //     )
  //   //     .then((res) => {
  //   //       // console.log(res.data.valid);
  //   //       res.data.valid ? setValidity(true) : setValidity(false);
  //   //     });
  //   // };
  //   e.preventDefault();
  //   axios({
  //     method: "POST",
  //     // url: "https://aqueous-plains-06808.herokuapp.com/api/v1/users/login",
  //     url: "https://lvh.me:5000/api/v1/users/sign_up",
  //     headers: {
  //       "content-type": "application/json",
  //     },
  //     data: {
  //       email: name,
  //       password: pass,
  //     },
  //   })
  //     .then((response) => {
  //       if (response.data.access_token) {
  //         toast.success("Sign up successful..", { position: "top-left" });
  //         localStorage.setItem("token", response.data.access_token);
  //         localStorage.setItem("email", name);
  //         // setLoggedIn(true);
  //         // history.push("./myProfile");
  //         // closeModal(true);
  //         // logged();
  //       } else {
  //         // history.push("./");
  //         toast("Try again..");
  //       }
  //     })
  //     .catch((error) => {
  //       console.error(error.response); // so that we know what went wrong if the request failed
  //       toast("Try again..");
  //     });
  // };

  const handleUsernameInput = (e) => {
    clearTimeout(delayId);
    const newName = e.target.value;
    setname(newName);
    const newDelayId = setTimeout(() => {
      // userCheck(newName);
      console.log(newName);
    }, 500);
    setDelay(newDelayId);
  };
  const getFormFeedback = () => {
    if (!name.length) {
      return null;
    }

    if (name.length <= 6) {
      return <FormFeedback invalid>Must be at least 6 characters</FormFeedback>;
    }

    if (nameValidity) {
      return <FormFeedback valid>Sweet! That name is available</FormFeedback>;
    } else {
      return <FormFeedback invalid>Sorry! Username is taken</FormFeedback>;
    }
  };

  const getInputProp = () => {
    if (!name.length) {
      return null;
    }

    if (name.length <= 6) {
      return { invalid: true };
    }

    if (nameValidity) {
      return { valid: true };
    } else {
      return { invalid: true };
    }
  };

  return (
    <Form>
      <FormGroup>
        <Label for="name">Username</Label>
        <Input
          {...getInputProp()}
          value={name}
          onChange={handleUsernameInput}
        />
        {getFormFeedback()}
        {getFormFeedback() == null ? (
          <FormText>Enter a username between 6 and 20 characters</FormText>
        ) : (
          ""
        )}
      </FormGroup>
      <FormGroup>
        <Label for="exampleEmail">e-mail</Label>
        <Input
          invalid
          value={email}
          onChange={(e) => {
            setemail(e.target.value);
          }}
        />
        {/* <FormFeedback>Oh noes! that name is already taken</FormFeedback>
          <FormText>Example help text that remains unchanged.</FormText> */}
      </FormGroup>

      <FormGroup>
        <Label for="examplePassword">password</Label>
        <Input
          type="password"
          value={pass}
          onChange={(e) => {
            setpass(e.target.value);
          }}
        />
        <FormFeedback tooltip>You will not be able to see this</FormFeedback>
        <FormText>Give a strong pass.</FormText>
      </FormGroup>
      <FormGroup>
        <Label for="examplePassword">Confirm password</Label>
        <Input
          type="password"
          value={Cpass}
          onChange={(a) => Csetpass(a.target.value)}
        />
        <FormFeedback tooltip>You will not be able to see this</FormFeedback>
        {Pcheck() ? (
          <FormText>matched</FormText>
        ) : (
          <FormText>didnt match</FormText>
        )}
      </FormGroup>
      <Button type="submit" onClick={newUser} disabled={!(enabled && Pcheck())}>
        Add User
      </Button>
    </Form>
  );
};

export default SignUp;
